import { createMuiTheme } from '@material-ui/core/styles';

// Custom theme for the app
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#4dabf5',
      main: '#2196f3',
      dark: '#1769aa',
      contrastText: '#fff'
    },
    secondary: {
      light: '#43c18c',
      main: '#15b270',
      dark: '#0e7c4e',
      contrastText: '#fff'
    },
    background: {
      default: '#fff'
    }
  }
});

export default theme;
